/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ agent: NonNullable<unknown> }} Console_Open_In_AgentInputs */

const en_console_open_in_agent = /** @type {(inputs: Console_Open_In_AgentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Open in ${i?.agent}`)
};

const zh_hans1_console_open_in_agent = /** @type {(inputs: Console_Open_In_AgentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`在 ${i?.agent} 中打开`)
};

const pt_br2_console_open_in_agent = /** @type {(inputs: Console_Open_In_AgentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abrir em ${i?.agent}`)
};

const es_console_open_in_agent = /** @type {(inputs: Console_Open_In_AgentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abrir en ${i?.agent}`)
};

const fr_console_open_in_agent = /** @type {(inputs: Console_Open_In_AgentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ouvrir dans ${i?.agent}`)
};

const de_console_open_in_agent = /** @type {(inputs: Console_Open_In_AgentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`In ${i?.agent} öffnen`)
};

const ru_console_open_in_agent = /** @type {(inputs: Console_Open_In_AgentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Открыть в ${i?.agent}`)
};

const it_console_open_in_agent = /** @type {(inputs: Console_Open_In_AgentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Apri in ${i?.agent}`)
};

/**
* | output |
* | --- |
* | "Open in {agent}" |
*
* @param {Console_Open_In_AgentInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const console_open_in_agent = /** @type {((inputs: Console_Open_In_AgentInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Console_Open_In_AgentInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_console_open_in_agent(inputs)
	if (locale === "pt-BR") return pt_br2_console_open_in_agent(inputs)
	if (locale === "es") return es_console_open_in_agent(inputs)
	if (locale === "fr") return fr_console_open_in_agent(inputs)
	if (locale === "de") return de_console_open_in_agent(inputs)
	if (locale === "ru") return ru_console_open_in_agent(inputs)
	if (locale === "it") return it_console_open_in_agent(inputs)
	return en_console_open_in_agent(inputs)
});